"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AnimationLayerFactory_1 = require("./AnimationLayerFactory");
var AnimationLayersArray = (function (_super) {
    tslib_1.__extends(AnimationLayersArray, _super);
    function AnimationLayersArray(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.getLayers = function () {
            return _this.layers;
        };
        _this.findFirstLayerByName = function (name) {
            var results = _this.findLayersByName(name);
            if (results === undefined || results.length < 1) {
                return undefined;
            }
            else {
                return results[0];
            }
        };
        _this.findLayersByName = function (name) {
            return _this.layersByNameMap[name];
        };
        _this.findLayerByIndex = function (index) {
            return _this.layers[index - 1];
        };
        _this.layers = [];
        _this.layersByNameMap = {};
        rawData.forEach(function (rawLayerData) {
            try {
                var layer = AnimationLayerFactory_1.constructLayerFromRawData(rawLayerData, version);
                _this.layers[layer.index - 1] = layer;
                var layerNameArray = _this.layersByNameMap[layer.name];
                if (layerNameArray === undefined) {
                    layerNameArray = [];
                    _this.layersByNameMap[layer.name] = layerNameArray;
                }
                layerNameArray.push(layer);
            }
            catch (err) {
                console.error("Error while trying to read layer " + rawLayerData.nm + ": " + err);
            }
        });
        return _this;
    }
    return AnimationLayersArray;
}(AnimationObject_1.AnimationObject));
exports.AnimationLayersArray = AnimationLayersArray;
//# sourceMappingURL=AnimationLayersArray.js.map